import React, { FC } from 'react';

import { useTranslation } from 'Modules/core/i18n';
import { Box, Skeleton, Stack, Typography, useDesktop, useMediaSwitch, useMobile } from 'Modules/ui3';

import { CfaHubIcon } from '../../components/CfaHubIcon';
import { ReactComponent as MTSLogo } from './assets/MTSLogo.svg';


interface MonitoringProps {
    value?: string;
}

export const Monitoring: FC<MonitoringProps> = ({ value }) => {
    const { t } = useTranslation('monitoring');
    const isDesktop = useDesktop();
    const isMobile = useMobile();

    return (
        <Stack
            py={isMobile ? 22 : 37}
            px={useMediaSwitch(12, 6, 5)}
            alignItems='center'
            zIndex={3}
            bgcolor='#fff'
            {...!isDesktop && {
                mt: -10,
                sx: {
                    borderTopLeftRadius: '40px',
                    borderTopRightRadius: '40px',
                },
            }}
        >
            <Stack spacing={isMobile ? 6 : 12} alignItems='center' maxWidth='1200px'>
                <CfaHubIcon size={isMobile ? 12 : 22} borderRadius={isMobile ? 4.5 : 8} />
                <Stack spacing={isMobile ? 4 : 8} alignItems='center'>
                    <Typography
                        fontFamily='Hauora'
                        fontSize={useMediaSwitch('64px', '56px', '36px')}
                        lineHeight='1.3'
                        fontWeight='700'
                        color='#B4B3AF'
                        textAlign='center'
                        width='100%'
                        sx={{
                            '&>span>span': {
                                color: '#242424',
                            },
                        }}
                    >
                        {value ? t(isDesktop ? 'usersDesktop' : 'users', { count: value })
                            : (
                                <Stack component='span' alignItems='center'>
                                    <Skeleton width='70%' sx={{ borderRadius: 12 }} />
                                    <Skeleton width='60%' sx={{ borderRadius: 12 }} />
                                </Stack>
                            )}
                    </Typography>
                    <Stack direction='row' spacing={1} flexWrap='wrap' alignItems='center' justifyContent='center'>
                        <Typography
                            variant={isMobile ? 'regularBody2' : 'regularHeader2'}
                            color='#B4B3AF'
                            fontFamily='Hauora'
                        >
                            {t('description1')}
                        </Typography>
                        <Stack direction='row' spacing={isDesktop ? 4 : 2} alignItems='center'>
                            <Typography
                                variant={isMobile ? 'regularBody2' : 'regularHeader2'}
                                color='#B4B3AF'
                                fontFamily='Hauora'
                            >
                                {t('description2')}
                            </Typography>
                            <Box
                                component={MTSLogo}
                                width={({ spacing }) => spacing(isDesktop ? 8 : 6)}
                                height={({ spacing }) => spacing(isDesktop ? 8 : 6)}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};
